import { Link } from "react-router-dom";
import { useState } from "react";
import ConfirmModal from "components/common/ConfirmModal";
import { MdVisibility, MdEdit, MdDelete } from "react-icons/md";

export default function ExhibitionEventTable({
  data = [],
  onDelete,
  onRefresh,
}) {
  const [deleteId, setDeleteId] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleDelete = async () => {
    try {
      setLoading(true);
      await onDelete(deleteId);
      setDeleteId(null);
      onRefresh();
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="overflow-hidden rounded-xl bg-white shadow-sm">
        <table className="w-full text-left">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-4 text-sm font-semibold text-gray-600">
                Event Name
              </th>
              <th className="px-6 py-4 text-sm font-semibold text-gray-600">
                Exhibitor
              </th>
              <th className="px-6 py-4 text-sm font-semibold text-gray-600">
                Status
              </th>
              <th className="px-6 py-4 text-sm font-semibold text-gray-600 text-right">
                Actions
              </th>
            </tr>
          </thead>

          <tbody className="divide-y">
            {data.length === 0 ? (
              <tr>
                <td
                  colSpan="4"
                  className="px-6 py-10 text-center text-sm text-gray-500"
                >
                  No Exhibitor Events found
                </td>
              </tr>
            ) : (
              data.map((item) => (
                <tr
                  key={item._id}
                  className="hover:bg-gray-50 transition"
                >
                  <td className="px-6 py-4 font-medium text-gray-800">
                    {item.event_name || "-"}
                  </td>

                  <td className="px-6 py-4 text-gray-600">
                    {item.exhibitor_id?.title || "-"}
                  </td>

                  <td className="px-6 py-4">
                    <span
                      className={`rounded-full px-3 py-1 text-xs font-semibold ${
                        item.status === "active"
                          ? "bg-green-100 text-green-700"
                          : "bg-gray-200 text-gray-600"
                      }`}
                    >
                      {item.status}
                    </span>
                  </td>

                  <td className="px-6 py-4">
                    <div className="flex justify-end gap-3">
                      <Link
                        to={`/admin/exhibitor-events/view/${item._id}`}
                        title="View"
                        className="rounded-lg p-2 text-gray-600 hover:bg-gray-100 hover:text-brand-500"
                      >
                        <MdVisibility size={18} />
                      </Link>

                      <Link
                        to={`/admin/exhibitor-events/edit/${item._id}`}
                        title="Edit"
                        className="rounded-lg p-2 text-gray-600 hover:bg-gray-100 hover:text-blue-600"
                      >
                        <MdEdit size={18} />
                      </Link>

                      <button
                        title="Delete"
                        onClick={() => setDeleteId(item._id)}
                        className="rounded-lg p-2 text-gray-600 hover:bg-red-50 hover:text-red-600"
                      >
                        <MdDelete size={18} />
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      <ConfirmModal
        open={Boolean(deleteId)}
        title="Delete Exhibition"
        message="This action cannot be undone. Do you want to continue?"
        confirmText="Delete"
        loading={loading}
        onConfirm={handleDelete}
        onCancel={() => setDeleteId(null)}
      />
    </>
  );
}
